export default __webpack_public_path__ + "static/media/file.3651812c.png";